module.exports = __webpack_public_path__ + "static/media/team_06.6f4de6a0.png";